import React from 'react'
import CheckRoundedIcon from '@material-ui/icons/CheckRounded'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import iconStyle from 'component/icon/iconStyle'
import cx from 'classnames'

const CheckIcon = (props) => {
  const {className, classes, ...rest} = props

  return <CheckRoundedIcon {...rest} className={cx(className, classes.checkIcon)} />
}

CheckIcon.propTypes = {
  className: PropTypes.object,
  classes: PropTypes.object,
  rest: PropTypes.object,
}

export default withStyles(iconStyle)(CheckIcon)
